import { render, staticRenderFns } from "./AddPhoneNumberModal.vue?vue&type=template&id=d5c70e3a&"
import script from "./AddPhoneNumberModal.vue?vue&type=script&lang=ts&"
export * from "./AddPhoneNumberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports